<template>
  <footer>
    <section class="section-footer-me">
      <img class="logo" src="https://res.cloudinary.com/dyikvzcke/image/upload/v1755469812/LOGO_SKF_1-removebg-preview_zfcosc.webp" alt="Logo de Rodamientos Huanuco" />
      <p>
        Distribuidor autorizado de repuestos industriales y automotricez en la
        marca SKF con mas de 35 años de experiencia. Tambien ofrecemos los
        productos que necesitas en diferentes marcas.
      </p>
    </section>

    <section class="section-footer-pages">
      <h6>Cotiza por WhatsApp</h6>
      <ul>
        <li>
          <FontAwesomeIcon :icon="faWhatsapp" style="opacity: 0.7;" />
          <span> +51 994 247 830</span>
        </li>
        <li>
          <FontAwesomeIcon :icon="faWhatsapp" style="opacity: 0.7;"/>
          <span to="/productos" class="item-option"> +51 994 247 832</span>
        </li>
        <li>
          <FontAwesomeIcon :icon="faWhatsapp" style="opacity: 0.7;"/>
          <span to="/acerca-de" class="item-option"> +51 993 381 769</span>
        </li>
      </ul>
    </section>

    <section class="section-footer-contact">
      <h6>Encuentranos aquí</h6>
      <div>
        <p>
          <font-awesome-icon :icon="faLocationDot" style="opacity: 0.7;"/>
          Av. Aviacion 1954 Urb. Santa Catalina Lima - 13 Perú. (Referencia)
          FRENTE A LA VIDENA DEPORTIVA.
        </p>
        <p> <font-awesome-icon :icon="faPhone" style="opacity: 0.7;"/> (01) 224-8385</p>
        <p><font-awesome-icon :icon="faInbox" style="opacity: 0.7;"/> ventas@skfhuanuco.com</p>
        <p><font-awesome-icon :icon="faInbox" style="opacity: 0.7;"/> huanuco@skfhuanuco.com</p>
        <p>
          <font-awesome-icon :icon="faClock" style="opacity: 0.7;" />
          Lunes - Vier 8AM - 6PM <br />
          Sábados 8AM - 3PM
        </p>
      </div>
    </section>
  </footer>
</template>

<script lang="ts" setup>
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faClock, faInbox, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  background-color: #fff;
  margin-top: 150px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 80px;
  padding-inline: 300px;
  padding-block: 80px;

  .section-footer-me {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: start;
    gap: 20px;
    .logo {
      width: 350px;
      filter: grayscale(100%);
    }
    h4 {
      font-size: 32px;
      font-weight: 600;
      color: $tint1;
    }

    p {
      font-size: $Tmedium;
      color: $shade1;
      opacity: 0.6;
    }
  }

  .section-footer-pages {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: start;
    gap: 20px;

    h6 {
      font-size: $Txmedium;
      font-weight: 400;
      color: $shade1;
    }

    ul {
      text-align: start;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 20px;
      list-style: none;
    }

    ul li span {
      list-style: none;
      color: $shade1;
      opacity: 0.6;
    }
  }

  .section-footer-contact {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: start;
    gap: 20px;

    h6 {
      font-size: $Txmedium;
      font-weight: 400;
      color: $shade1;
    }

    div {
      display: flex;
      flex-direction: column;
      gap: 10px;
      color: $shade1;
      opacity: 0.6;
    }
  }
}

@media (max-width: 1600px) {
  footer {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
    gap: 50px;
    row-gap: 100px;
    padding-inline: 100px;
  }
}

@media (max-width: 1080px) {
  /* RESET DEL FOOTER */
  footer {
    padding-inline: 80px;
  }
}

@media (max-width: 580px) {
  footer {
    grid-template-columns: auto;
    padding-inline: 20px;
    justify-content: center;
  }
}
</style>
